// extracted by mini-css-extract-plugin
module.exports = {"card":"icon-card_card__cHO7h"};